module.exports = __webpack_public_path__ + "fonts/accc827.ttf";